import 'dayjs/locale/ko';

import dayjs from 'dayjs';
import intl from 'react-intl-universal';

import en from '@/locale/en.json';
import ko from '@/locale/ko.json';

export const DEFAULT_LANGUAGE = /^en\b/.test(window.navigator.language) ? 'en' : 'ko';

const LOCALES = { en, ko };

export const setLocaleInWebView = (locale: SpenditLocale = DEFAULT_LANGUAGE): void => {
  intl.init({
    currentLocale: locale,
    locales: LOCALES,
  });
};

export const setLocale = async (locale: SpenditLocale = DEFAULT_LANGUAGE): Promise<void> => {
  document.documentElement.lang = locale;
  dayjs.locale(locale);

  return intl.init({
    currentLocale: locale,
    locales: LOCALES,
  });
};

export const getLocale = (): string => {
  return intl.getInitOptions().currentLocale;
};

export const translate = (key: string, variables?: unknown): string => {
  return intl.get(key, variables);
};

export const translateHTML = (key: string, variables?: unknown): string => {
  return intl.getHTML(key, variables);
};
